<template>
  <h3 class="fz-22 text-accent mb-12.5" style="line-height: 1.3636;">{{text}}</h3>
</template>

<script>
export default {
  name: "sectionHeader",
  props: ['text']
}
</script>

<style scoped>

</style>